import { RELEASE_NOTES } from '../lib/releaseNotes';
import { t } from '../lib/i18n';
import { Card, PageHeader } from '../components/ui';

/** "What's new": the customer-facing release notes (web/src/lib/releaseNotes.ts). Needs no server call. */
export function WhatsNewPage() {
  return (
    <>
      <PageHeader title={t('whatsNew.title')} description={t('whatsNew.description')} />
      <div className="space-y-4">
        {RELEASE_NOTES.map((r) => (
          <Card key={r.version} title={r.title}>
            <p className="mb-2 text-sm text-slate-600">
              {t('whatsNew.version', { version: r.version })} &middot; {t('whatsNew.date', { date: r.date })}
            </p>
            <ul className="list-disc space-y-1 pl-5 text-sm text-slate-800">
              {r.points.map((p) => (
                <li key={p}>{p}</li>
              ))}
            </ul>
          </Card>
        ))}
      </div>
    </>
  );
}
